import { FadeUp } from "@/components/Reveal";

const LINKS = [
  { id: "about", label: "The Firm" },
  { id: "practice", label: "Practice Areas" },
  { id: "clients", label: "Clients" },
  { id: "fees", label: "Fees & Ethics" },
  { id: "journal", label: "Legal Updates" },
  { id: "contact", label: "Contact" },
];

export default function Footer({ onNavigate }) {
  return (
    <footer data-testid="site-footer" className="relative border-t border-gold/15 pt-20 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <FadeUp>
          <div className="flex flex-col lg:flex-row justify-between gap-12">
            <div className="max-w-md">
              <div className="flex items-center gap-4">
                <img
                  src="/assets/logo.jpg"
                  alt="Musesya & Company Advocates seal"
                  className="h-14 w-14 rounded-full object-cover ring-1 ring-gold/50"
                />
                <div className="font-display text-lg tracking-[0.12em] leading-snug">
                  MUSESYA <span className="text-gold">&amp;</span> COMPANY
                  <br />
                  ADVOCATES
                </div>
              </div>
              <p className="mt-6 text-sm text-ink-dim leading-relaxed">
                Muthaiga Square, 2nd Floor Room 15, Thika Road, Nairobi &middot;
                P.O. Box 254720577583 &ndash; 00100 &middot; sakimlaw@gmail.com
                &middot; 0720 577 583 / 0736 981 614
              </p>
            </div>

            <nav className="flex flex-col gap-3">
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold mb-1">
                Navigate
              </span>
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`footer-link-${l.id}`}
                  onClick={() => onNavigate(l.id)}
                  className="text-left text-sm text-ink-dim hover:text-gold transition-colors"
                >
                  {l.label}
                </button>
              ))}
            </nav>

            <div className="max-w-xs">
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">
                Notice
              </span>
              <p className="mt-4 text-xs text-ink-muted leading-relaxed">
                This website is for general information only and does not
                constitute legal advice or create an advocate&ndash;client
                relationship. Governed by The Advocates Act and The Advocates
                Practice Rules of Kenya.
              </p>
            </div>
          </div>
        </FadeUp>

        <FadeUp delay={0.15}>
          <div className="gold-hairline mt-16 mb-8" />
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="font-mono text-xs text-ink-muted tracking-wider">
              &copy; {new Date().getFullYear()} Musesya &amp; Company Advocates. All rights reserved.
            </p>
            <p className="font-editorial italic text-sm text-ink-dim">
              Est. April 2018 &mdash; Nairobi, Kenya
            </p>
          </div>
        </FadeUp>
      </div>
    </footer>
  );
}
